class XeroAuthController extends AbstractIntegrationController
	@register()
	@inject '$stateParams',
		'IntegrationRepository'

	integrationId: 'xero'

	initialize: ->
		if @$stateParams.error
			@goToConfigPage()
			return

		@IntegrationRepository
			.customPost @integrationId, 'connect', {code: @$stateParams.code}
			.then =>
				@goToConfigPage()
			.catch (response) =>
				console.error response
				@goToConfigPage()
